import React from 'react';
import { Dropdown, Button } from 'antd';
import PropTypes from 'prop-types';

const FilterDropdown = ({
  sections,
  selectedFilter,
  onFilterChange,
  buttonLabel = 'Status',
  disabled = false,
}) => {
  const menuItems = sections.flatMap((section) => {
    const headerItem = section.title
      ? [
          {
            key: `header-${section.title}`,
            label: section.title,
            disabled: true,
          },
        ]
      : [];

    const sectionItems = section.items.map((item) => ({
      ...item,
      label: (
        <div className="dropdown-label">
          <span>{item.label}</span>
          {selectedFilter && selectedFilter[section.type] === item.key && (
            <img
              src="/assets/icons/filter-active.svg"
              alt="Selected"
              className="checkmark-icon"
            />
          )}
        </div>
      ),
      onClick: () => {
        const isActive =
          selectedFilter && selectedFilter[section.type] === item.key;

        onFilterChange({ [section.type]: isActive ? null : item.key });
      },
    }));

    return [...headerItem, ...sectionItems];
  });

  return (
    <Dropdown
      menu={{ items: menuItems }}
      trigger={['click']}
      placement="bottomLeft"
      className={'btn-filter-container'}
      disabled={disabled}
    >
      <Button className="btn-tertiary btn-filter" disabled={disabled}>{buttonLabel}</Button>
    </Dropdown>
  );
};

FilterDropdown.propTypes = {
  sections: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string,
      items: PropTypes.arrayOf(
        PropTypes.shape({
          key: PropTypes.string.isRequired,
          label: PropTypes.node.isRequired,
          type: PropTypes.string,
          onClick: PropTypes.func,
        })
      ).isRequired,
    })
  ).isRequired,
  selectedFilter: PropTypes.shape({
    type: PropTypes.string,
    value: PropTypes.string,
  }),
  onFilterChange: PropTypes.func.isRequired,
  buttonLabel: PropTypes.string,
  disabled: PropTypes.bool,
};

FilterDropdown.defaultProps = {
  selectedFilter: null,
  buttonLabel: 'Filter',
};

export default FilterDropdown;
